import React from "react";
import { Button, Card, Form } from "react-bootstrap";
import moment from "moment";
import "./ProjectWorkflowTab.css";

const ProjectWorkflowTab = ({
  // Data
  templates,
  templatesLoading,

  // Handlers
  handleCreateTemplate,
  handleEditTemplate,
  handleDeleteTemplate,
  getFieldDisplayName,
}) => {
  return (
    <div className="pwf-workflow-container">
      <div className="pwf-main-card">
        <div className="pwf-header">
          <div className="pwf-header-left">
            <div className="pwf-header-icon">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM9 17H7V10H9V17ZM13 17H11V7H13V17ZM17 17H15V13H17V17Z"
                  fill="currentColor"
                />
              </svg>
            </div>
            <div>
              <h3 className="pwf-title">Task Templates</h3>
              <p className="pwf-subtitle">
                Create and manage reusable task templates
              </p>
            </div>
          </div>
          <Button
            variant="primary"
            className="pwf-create-btn"
            onClick={handleCreateTemplate}
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
                fill="currentColor"
              />
            </svg>
            Create Template
          </Button>
        </div>

        {/* Task Templates List */}
        <div className="pwf-templates-container">
          {templatesLoading ? (
            <div className="pwf-loading-state">
              <div className="pwf-loading-spinner"></div>
              <p>Loading templates...</p>
            </div>
          ) : templates.length === 0 ? (
            <div className="pwf-empty-state">
              <div className="pwf-empty-icon">
                <svg
                  width="80"
                  height="80"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM9 17H7V10H9V17ZM13 17H11V7H13V17ZM17 17H15V13H17V17Z"
                    fill="currentColor"
                  />
                </svg>
              </div>
              <h5 className="pwf-empty-title">No Task Templates</h5>
              <p className="pwf-empty-message">
                Create your first task template to streamline task creation and
                ensure consistency across projects.
              </p>
              <Button
                variant="outline-primary"
                className="pwf-empty-create-btn"
                onClick={handleCreateTemplate}
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
                    fill="currentColor"
                  />
                </svg>
                Create Your First Template
              </Button>
            </div>
          ) : (
            <div className="pwf-templates-grid">
              {templates.map((template, index) => (
                <div
                  key={template.templateId}
                  className="pwf-template-card"
                  style={{ animationDelay: `${index * 0.05}s` }}
                >
                  <div className="pwf-card-header">
                    <div className="pwf-card-title-section">
                      <div className="pwf-card-icon">
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13V9H18V20Z"
                            fill="currentColor"
                          />
                        </svg>
                      </div>
                      <div>
                        <h6 className="pwf-card-title">
                          {template.templateName}
                        </h6>
                        {template.templateDescription && (
                          <p className="pwf-card-description">
                            {template.templateDescription}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="pwf-card-actions">
                      <Button
                        variant="link"
                        className="pwf-action-btn pwf-edit-btn"
                        onClick={() => handleEditTemplate(template)}
                        title="Edit Template"
                      >
                        Edit
                        {/* <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
                            fill="currentColor"
                          />
                        </svg> */}
                      </Button>
                      <Button
                        variant="link"
                        className="pwf-action-btn pwf-delete-btn"
                        onClick={() =>
                          handleDeleteTemplate(template.templateId)
                        }
                        title="Delete Template"
                      >
                        Delete
                        {/* <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
                            fill="currentColor"
                          />
                        </svg> */}
                      </Button>
                    </div>
                  </div>

                  <div className="pwf-card-body">
                    <div className="pwf-fields-section">
                      <div className="pwf-fields-header">
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM8 11H6V9h2v2zm4 0h-2V9h2v2zm4 0h-2V9h2v2z"
                            fill="currentColor"
                          />
                        </svg>
                        <span className="pwf-fields-label">
                          Fields Included (
                          {Object.keys(template.includeFields || {}).length})
                        </span>
                      </div>
                      <div className="pwf-fields-tags">
                        {Object.keys(template.includeFields || {}).map(
                          (fieldName) => (
                            <span key={fieldName} className="pwf-field-tag">
                              {getFieldDisplayName(fieldName)}
                            </span>
                          ),
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="pwf-card-footer">
                    <div className="pwf-footer-info">
                      <svg
                        width="12"
                        height="12"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"
                          fill="currentColor"
                        />
                      </svg>
                      <span>
                        Created{" "}
                        {moment(template.createdOnDate).format("MMMM DD, YYYY")}
                      </span>
                    </div>
                    <div className="pwf-footer-badge">
                      <svg
                        width="12"
                        height="12"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
                          fill="currentColor"
                        />
                      </svg>
                      <span>
                        Template ID: {template.templateId.substring(0, 8)}...
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProjectWorkflowTab;

// import React from "react";
// import { Button, Card, Form } from "react-bootstrap";
// import moment from "moment";

// const ProjectWorkflowTab = ({
//   // Data
//   templates,
//   templatesLoading,

//   // Handlers
//   handleCreateTemplate,
//   handleEditTemplate,
//   handleDeleteTemplate,
//   getFieldDisplayName,
// }) => {
//   return (
//     <div className="project-view-fade-in">
//       <div className="project-overview-single-card">
//         <div className="d-flex justify-content-between align-items-center mb-4">
//           <h3 className="project-view-overview-section-title">
//             Task Templates
//           </h3>
//           <Button variant="primary" size="sm" onClick={handleCreateTemplate}>
//             Create Template
//           </Button>
//         </div>

//         {/* Task Templates List */}
//         <div className="templates-container">
//           {templatesLoading ? (
//             <div className="text-center py-4">
//               <div className="spinner-border text-primary" role="status">
//                 <span className="visually-hidden">Loading templates...</span>
//               </div>
//             </div>
//           ) : templates.length === 0 ? (
//             <div className="text-center py-5 text-muted">
//               <i className="fas fa-clipboard-list fa-3x mb-3"></i>
//               <h5>No Task Templates</h5>
//               <p>
//                 Create your first task template to streamline task creation.
//               </p>
//               <Button
//                 variant="outline-primary"
//                 size="sm"
//                 onClick={handleCreateTemplate}
//               >
//                 Create Your First Template
//               </Button>
//             </div>
//           ) : (
//             <div className="row">
//               {templates.map((template) => (
//                 <div key={template.templateId} className="col-md-6 mb-3">
//                   <Card className="template-card h-100">
//                     <Card.Body>
//                       <div className="d-flex justify-content-between align-items-start mb-2">
//                         <Card.Title className="h6 mb-0">
//                           {template.templateName}
//                         </Card.Title>
//                         <div className="template-actions">
//                           <Button
//                             variant="outline-primary"
//                             size="sm"
//                             className="me-1"
//                             onClick={() => handleEditTemplate(template)}
//                             title="Edit Template"
//                           >
//                             <i className="fas fa-edit"></i>
//                           </Button>
//                           <Button
//                             variant="outline-danger"
//                             size="sm"
//                             onClick={() =>
//                               handleDeleteTemplate(template.templateId)
//                             }
//                             title="Delete Template"
//                           >
//                             <i className="fas fa-trash"></i>
//                           </Button>
//                         </div>
//                       </div>

//                       {template.templateDescription && (
//                         <Card.Text className="text-muted small mb-2">
//                           {template.templateDescription}
//                         </Card.Text>
//                       )}

//                       <div className="template-fields">
//                         <small className="text-muted">
//                           <strong>Fields included:</strong>{" "}
//                           {Object.keys(template.includeFields || {}).length}
//                         </small>
//                         <div className="field-tags mt-1">
//                           {Object.keys(template.includeFields || {}).map(
//                             (fieldName) => (
//                               <span
//                                 key={fieldName}
//                                 className="badge bg-light text-dark me-1 mb-1"
//                               >
//                                 {getFieldDisplayName(fieldName)}
//                               </span>
//                             ),
//                           )}
//                         </div>
//                       </div>

//                       <div className="template-footer mt-3 pt-2 border-top">
//                         <small className="text-muted">
//                           Created:{" "}
//                           {moment(template.createdOnDate).format(
//                             "MMM DD, YYYY",
//                           )}
//                         </small>
//                       </div>
//                     </Card.Body>
//                   </Card>
//                 </div>
//               ))}
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ProjectWorkflowTab;
